export default __webpack_public_path__ + "static/media/squares1300.56891be6.jpg";